// Check if the given param is an object. Used to check if an error object exists or is empty

export const isObjectWithKeys = (obj: object | undefined | null) => {
    if (obj && typeof obj === "object") {
        return Object.keys(obj).length !== 0;
    }

    return false;
};
